import Button from '$partials/ui/button';
import React from 'react';
import { SwiperSlide } from 'swiper/react';

import { formatLinkBlockToUrl } from '$utilities/data';
import IconArrow from '$partials/icons/icon-arrow';
import { Carousel, CarouselWrapper, CarouselPagination } from '$partials/base/carousel';
import { SimpleImage } from '$partials/media';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').VerticalTextAndImage}
 */

const VerticalTextAndImage = ({
    images,
    heading,
    items
}) => {
    return (
        <div className='module-image-card-stacked theme-light bg-main-background py-24 sm:py-40 md:py-48'>
            {images?.length > 0 && (
                <Carousel
                    swiperConfig={{
                        a11y: { enabled: true },
                        slidesPerView: 1,
                        grabCursor: false,
                    }}>
                    <div className='relative'>
                        <CarouselWrapper>
                            {images?.map((item) => {
                                return (
                                    <SwiperSlide
                                        aria-roledescription='slide'
                                        className='select-none cursor-pointer'
                                        key={item.id}
                                        role='group'>
                                        <SimpleImage
                                            className='w-full h-[195px] sm:h-[395px] md:h-[740px] object-cover'
                                            {...item?.image}/>

                                    </SwiperSlide>
                                );
                            })}
                        </CarouselWrapper>
                        {images?.length > 1 && (
                            <CarouselPagination totalSlides={images.length} />
                        )}
                    </div>
                </Carousel>
            )}
            <div className='layout-container layout-site-outer-padding pt-32'>
                <div className='col-wrapper'>
                    {/* Heading Section */}
                    <div className='flex flex-col md:flex-row'>
                        {heading && (
                            <div className='mb-24 col-padding md:w-4/12'>
                                <h2 className='type-style-2'>
                                    {heading}
                                </h2>
                            </div>
                        )}
                        <div className='grid grid-cols-1 sm:grid-cols-2 md:w-8/12 gap-y-48'>
                            {items?.map((textItem, index) => {
                                return (
                                    <div
                                        className={`flex justify-between items-start flex-col gap-12 col-padding md:border-l border-main-border ${index % 2 === 0 ? 'sm:border-r md:border-r-0' : ''}`}
                                        key={textItem.id || index}>
                                        {textItem?.heading && (
                                            <h3 className='type-style-3 text-main-text-primary'>
                                                {textItem.heading}
                                            </h3>
                                        )}
                                        {textItem?.body && (
                                            <p className='type-style-body-r text-main-text-primary'>
                                                {textItem.body}
                                            </p>
                                        )}
                                        {textItem?.ctaLink && textItem?.ctaLabel && (
                                            <Button
                                                as='a'
                                                className='type-style-eyebrow hover:text-main-brand-text mt-16 flex items-center'
                                                href={formatLinkBlockToUrl(textItem.ctaLink)}>
                                                <span>
                                                    {textItem?.ctaLabel}
                                                </span>
                                                <IconArrow className='ml-8 inline-block h-[7px]'/>
                                            </Button>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default VerticalTextAndImage;
